import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram, Mail } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Footer = ({ content }) => {
  const { t } = useLang();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="footer" className="bg-slate-900 text-slate-300 pt-16 pb-8">
      <div className="container-x grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-heading font-extrabold text-2xl text-white">BERISHA</div>
          <div className="text-blue-400 text-xs tracking-[0.3em] uppercase mb-4">Autoaufbereitung</div>
          <p className="text-slate-400 max-w-md text-sm leading-relaxed">{t("footer.tagline")}</p>
          <div className="flex gap-3 mt-6">
            <a href={content.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram"
               className="w-11 h-11 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center text-slate-300 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={`tel:${content.phone?.replace(/\s/g, "")}`} data-testid="footer-phone-icon"
               className="w-11 h-11 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center text-slate-300 hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-all">
              <Phone className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">{t("footer.navigation")}</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            {[[t("nav.home"),"hero"],[t("nav.services"),"leistungen"],[t("nav.packages"),"pakete"],[t("nav.gallery"),"galerie"],[t("nav.reviews"),"bewertungen"],[t("nav.contact"),"kontakt"]].map(([l,id]) => (
              <li key={id}><button onClick={() => scrollTo(id)} className="hover:text-blue-400 transition-colors">{l}</button></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">{t("footer.contact")}</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-blue-400 mt-0.5 shrink-0" />{content.address}</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-blue-400 shrink-0" /><a href={`tel:${content.phone?.replace(/\s/g, "")}`} className="hover:text-blue-400">{content.phone}</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-blue-400 shrink-0" /><a href={`mailto:${content.email}`} className="hover:text-blue-400 break-all">{content.email}</a></li>
            <li className="flex items-center gap-2"><Instagram className="w-4 h-4 text-blue-400 shrink-0" />{content.instagram_handle}</li>
          </ul>
        </div>
      </div>

      <div className="container-x mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-slate-500">
        <span>© {new Date().getFullYear()} Autoaufbereitung Berisha. {t("footer.rights")}</span>
        <div className="flex gap-5">
          <Link to="/impressum" data-testid="footer-impressum" className="hover:text-blue-400">{t("footer.imprint")}</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-blue-400">{t("footer.privacy")}</Link>
          <Link to="/admin" data-testid="footer-admin" className="hover:text-blue-400">{t("footer.admin")}</Link>
        </div>
      </div>
    </footer>
  );
};
